
import { createContext } from 'react'
import { KeycloakTokenParsed } from 'keycloak-js';

type KeycloakContextContent = {
    token?: string,
    tokenParsed?: KeycloakTokenParsed,
    logout: () => Promise<void>,
    updateToken: (minValidity?: number) => Promise<boolean>,
}

export const KeycloakContext = createContext<KeycloakContextContent>({ logout: async () => {}, updateToken: async () => false  });
